import React from 'react';
import { StatusFilterValue, TApiApplicationDocument } from '~/modules/covenants/types.ts';
import { StatusChipWithTooltip } from '~/modules/covenants/components/StatusChipWithTooltip.tsx';
import {
  getGroupedDocumentStatusConfig,
  TGroupedDocumentRowStatus,
} from '~/modules/covenants/CovenantsDataApplicationForm/utils.ts';
import { covConstantsStyles } from '~/modules/covenants/constantsStyles.ts';

interface IDocStatusChipProps {
  doc: TApiApplicationDocument;
  status?: TGroupedDocumentRowStatus;
}

export const DocStatusChip: React.FC<IDocStatusChipProps> = ({ doc, status }) => {
  const statusKey = status ?? doc.status;
  const config = getGroupedDocumentStatusConfig(statusKey);

  return (
    <StatusChipWithTooltip
      label={config.label}
      color={config.color}
      description={config.description}
      chipSx={[
        covConstantsStyles.statusChip,
        statusKey === StatusFilterValue.Sent ? covConstantsStyles.processingStatusChip : null,
      ]}
    />
  );
};
